/**
 * NotFoundPage Component
 * AIDLC Administrative Backend
 *
 * Shown inside the layout for any URL with no page, so a wrong link or an old
 * bookmark (MSAL returns people to the URL they started from) is visible
 * instead of rendering a blank screen.
 */

import { Link, useLocation } from 'react-router-dom';

export function NotFoundPage() {
  const { pathname } = useLocation();

  return (
    <div data-testid="not-found" className="max-w-xl mx-auto mt-12 bg-white border border-zinc-200 rounded-lg p-6 dark:bg-zinc-900 dark:border-zinc-800">
      <h1 className="text-base font-semibold text-gray-800 dark:text-gray-100 mb-2">That page doesn't exist</h1>
      <p className="text-xs text-gray-600 dark:text-gray-300 mb-4">
        There is no page at <code className="bg-gray-100 dark:bg-zinc-800 px-1 rounded">{pathname}</code>. The link may be old or mistyped.
      </p>
      <Link to="/" className="text-xs font-medium text-ldaja-blue hover:underline">
        Go to the Dashboard
      </Link>
    </div>
  );
}
